module.exports = __webpack_public_path__ + "img/equips.54a9e38d.svg";